import { render, staticRenderFns } from "./DetalleAcreditamientoModal.vue?vue&type=template&id=072f48e8"
import script from "./DetalleAcreditamientoModal.vue?vue&type=script&lang=js"
export * from "./DetalleAcreditamientoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072f48e8')) {
      api.createRecord('072f48e8', component.options)
    } else {
      api.reload('072f48e8', component.options)
    }
    module.hot.accept("./DetalleAcreditamientoModal.vue?vue&type=template&id=072f48e8", function () {
      api.rerender('072f48e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleAcreditamientoModal.vue"
export default component.exports